// extracted by mini-css-extract-plugin
export default {"start":"ProjectPage_start__GQtY8","project":"ProjectPage_project__kKxBc","title":"ProjectPage_title__A9EGz","select":"ProjectPage_select__USqFN"};